import PerfectScrollbar from 'perfect-scrollbar';

const TABLE_WITH_SCROLL_CLASS = 'with-scroll';

const initSectionTable = () => {
	document.querySelectorAll( 'section.table' ).forEach( ( component ) => {
		const tableWrapper = component.querySelector( 'div.table-wrapper' );
		const backgroundHeader = component.querySelector( 'span.background > span.header' );
		
		if ( !tableWrapper )
		{
			return;
		}
		
		const table = tableWrapper.querySelector( 'table' );
		
		if ( !table )
		{
			return;
		}
		
		const ps = new PerfectScrollbar(
			tableWrapper,
			{
				wheelPropagation: true,
				suppressScrollY: true,
			},
		);
		
		if ( tableWrapper.classList.contains( 'contrasting-lines' ) )
		{
			tableWrapper.classList.add( 'with-background' );
		}
		
		const checkTableOverflow = () => {
			const tableHeader = table.querySelector( 'tr' );
			const tableStyle = table.currentStyle || window.getComputedStyle( table );
			let tableWidth = table.offsetWidth;
			
			if ( tableStyle )
			{
				const marginLeft = parseInt( tableStyle.marginLeft, 10 );
				const marginRight = parseInt( tableStyle.marginRight, 10 );
				
				if ( marginLeft )
				{
					tableWidth += marginLeft;
				}
				
				if ( marginRight )
				{
					tableWidth += marginRight;
				}
			}
			
			if ( tableWidth > tableWrapper.offsetWidth )
			{
				tableWrapper.classList.add( TABLE_WITH_SCROLL_CLASS );
			}
			else
			{
				tableWrapper.classList.remove( TABLE_WITH_SCROLL_CLASS );
			}
			
			if ( tableHeader && backgroundHeader )
			{
				backgroundHeader.style.height = `${tableHeader.offsetHeight + 1}px`;
			}
			
			ps.update();
		};
		
		window.addEventListener( 'resize', () => {
			checkTableOverflow();
		} );
		
		window.addEventListener( 'load', () => {
			checkTableOverflow();
		} );
		
		checkTableOverflow();
	} );
};

export {
	initSectionTable,
};
